export enum QuestionType {
  InfoSection = 'info_section',
  Text = 'text',
  MultipleChoice = 'multiple_choice',
  Date = 'date',
  Time = 'time',
  Number = 'number',
  Checkbox = 'checkbox',
  Email = 'email',
  Url = 'url',
  Phone = 'phone',
}

export interface FormQuestion extends ApiEntity {
  formId: id
  position: number
  text: string
  longAnswer: boolean
  required: boolean
  questionType: QuestionType
  options?: string[] // multiple choice options
}

export async function createFormQuesion(attributes: Partial<FormQuestion>) {
  return $create<FormQuestion>({
    resourceName: 'form_question',
    values: attributes,
    deserialize: true,
  })
}

export async function updateFormQuestion(id: id, attributes: Partial<FormQuestion>) {
  return $update<FormQuestion>({
    resourceName: 'form_question',
    id,
    values: attributes,
    deserialize: true,
  })
}

export async function deleteFormQuestion(id: id) {
  return $delete({
    instance: { id, type: 'form_question' } as FormQuestion,
    resourceName: 'form_question',
  })
}
